module.exports = __webpack_public_path__ + "media/SetA_L6_B.cbe7355b.mp3";